import { EventNames, globalEventBus } from '@littlebird/event-bus';
import { MAIN_CHAT_MODE } from '@littlebird/sdk';
import { formatPaywallSubtitle } from '@littlebird/ui-utils';
import { useParams } from '@tanstack/react-router';
import { useEffect } from 'react';

import { chatStore } from '@/features/chat/chat.store';
import { subscriptionApis } from '@/features/subscription/subscription.query';
import { subscriptionStore } from '@/features/subscription/subscription.store';
import { uiStore } from '@/stores/ui.store';

export const usePaywallStateEvents = () => {
  const { chatId } = useParams({ strict: false });

  useEffect(() => {
    const showPaywallBannerSubscription = globalEventBus.on(
      EventNames.PAYWALL_SHOW_BANNER,
      ({ data }) => {
        if (data.kind === 'rate_limit_reset') {
          const subtitle = formatPaywallSubtitle(
            data.nextAllowedTime,
            data.errorMessage
          );
          uiStore.showPaywallBanner({
            subtitle,
          });
          subscriptionApis.getStatus();
          if (data.errorCode === 'research_daily_limit') {
            if (chatId) {
              chatStore.setChatMode(MAIN_CHAT_MODE, chatId);
            }
            chatStore.setChatMode(MAIN_CHAT_MODE);
          }
          return;
        }

        if (subscriptionStore.isLiteModeActive) return;

        uiStore.showPaywallBanner({
          title: data.title,
          subtitle: data.subtitle,
        });
      }
    );

    const assistantFinishedSubscription = globalEventBus.on(
      EventNames.CHAT_ASSISTANT_DID_FINISH_MESSAGES,
      () => {
        subscriptionApis.getStatus();
      }
    );

    return () => {
      showPaywallBannerSubscription.unsubscribe();
      assistantFinishedSubscription.unsubscribe();
    };
  }, [chatId]);
};
